module.exports = __webpack_public_path__ + "img/Path_66842.099ee72d.svg";